import { Component, DestroyRef } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TranslocoDirective, TranslocoService } from "@jsverse/transloco";
import { Button } from "primeng/button";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { TagModule } from "primeng/tag";
import { finalize } from "rxjs";
import { DeleteInvitationDialogConfig } from "./delete-invitation-dialog.types";
import { AccessRoleColorSeverityMapping } from "../../../../domain/access-role";
import { InvitationDetails } from "../../../../domain/invitation";
import { InvitationsService } from "../../../../services/invitations.service";
import { ToastService } from "../../../../services/toast.service";
import { RanDatePipe } from "../../../../shared/pipes/ran-date.pipe";
import { PrimeNgSeverity } from "../../../../shared/types/primeng";

@Component({
  templateUrl: "./delete-invitation.dialog.html",
  imports: [TranslocoDirective, Button, RanDatePipe, TagModule],
})
export class DeleteInvitationDialog {
  public invitation: InvitationDetails;
  public loading = false;

  constructor(
    public readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig<DeleteInvitationDialogConfig>,
    private readonly invitationsService: InvitationsService,
    private readonly toastService: ToastService,
    private readonly translocoService: TranslocoService,
    private readonly destroyRef: DestroyRef,
  ) {
    if (!this.config.data?.invitation) {
      throw new Error("DeleteInvitationDialog: Missing required invitation.");
    }
    this.invitation = this.config.data.invitation;
  }

  public get roleName(): string {
    return this.invitation.userAccessRole.name;
  }

  public get roleSeverity(): PrimeNgSeverity {
    return AccessRoleColorSeverityMapping[this.invitation.userAccessRole.color] ?? "info";
  }

  public confirmDelete(): void {
    this.loading = true;

    this.invitationsService
      .deleteInvitation$(this.invitation.id)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.loading = false;
        }),
      )
      .subscribe({
        next: () => {
          this.toastService.success(
            this.translocoService.translate("app.organization-settings.invitations.deleteSuccess"),
          );
          this.ref.close({ invitation: this.invitation, isDeleted: true });
        },
        error: () => {
          this.toastService.error(this.translocoService.translate("app.common.errors.deleteError"));
        },
      });
  }
}
